import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { MotifIcon, MotifButton, MotifErrorMessage } from "@ey-xd/motif-react";
import { IconoirArrowLeft } from "@ey-xd/motif-icon";
import Button from "@/components/Form/Button/Button";
import Breadcrumb from "@/components/Breadcrumb/Breadcrumb";
import PageTitle from "@/components/Form/PageTitle/PageTitle";
import {
	SCHEME_NAME,

	SCHEME_DESC_NAME,
	SCHEME_NAME_FR,

	SCHEME_DESC_FR_NAME,
} from "./Constants";
import { CreateSchemeFormType } from "./type";
import ControlInputBox from "./ControlInputBoxScheme";
import {
	useCreateSchemeMutation,
} from "@/services/scheme/schemeReducer";
import NotificationGrid from "@/components/Notification/NotificationGrid";
import ConfirmationModal from "@/components/Modal/ConfirmationModal/ConfirmationModal";
import ControlTextAreaWithCharLimit from "@/components/Form/InputBox/ControlTextAreaWithCharLimit";
import { useDispatch, useSelector } from "react-redux";
import { setDiscardEditMode } from "@/components/Modal/ConfirmationModal/discardchanges";
import { CANCEL_BUTTON_VARIANT, SAVE_BUTTON_VARIANT } from "@/components/Images/CommonImages";
import { ActiveTabsOrder } from "@/menuData";

const SchemeSetup = () => {
	const { t } = useTranslation();
	const [isLoading, setIsLoading] = useState(false);
	const { caseId } = useParams();
	const [createStageQuery] = useCreateSchemeMutation();
	const [errorMessage, setErrorMessage] = useState("");
	const [isDiscardVisible, setIsDiscardVisible] = useState(false);
	const navigate = useNavigate();
	const dispatch=useDispatch()
	const { caseName } = useSelector((state: any) => state.case);

	
	const {
		handleSubmit,
		control,
		formState: { errors ,isDirty},
	} = useForm<CreateSchemeFormType>({
		defaultValues: {
			[SCHEME_NAME]: "",
			[SCHEME_NAME_FR]: "",
			[SCHEME_DESC_NAME]: "",
			[SCHEME_DESC_FR_NAME]: "",
		},
	});
useEffect(() => {
	dispatch(setDiscardEditMode({ editMode: isDirty }));
	return () => {
	  dispatch(setDiscardEditMode({ editMode: false }));
	};
  }, [dispatch,isDirty]);
	const onSubmit = async (formData: CreateSchemeFormType) => {
		setErrorMessage("");
		setIsLoading(true);
		const schemeData = {
			caseId: caseId,
			name: formData.schemeName,
			nameFrench: formData.schemeFrName,
			description: formData.schemeDescName,
			descriptionFrench: formData.shemeDescFrName,
		};
		dispatch(setDiscardEditMode({ editMode: false }));

		await createStageQuery(schemeData).then((response: any) => {
			if (response.hasOwnProperty("data")) {
				const schemeId = response.data;
				navigate(`/case/${caseId}/scheme-manage/${schemeId}`);
			} else {
				dispatch(setDiscardEditMode({ editMode: true }));
				setErrorMessage(response?.error?.data?.message || t("global.globalNotifications.unExpectedError"));
			}
			setIsLoading(false);
		});
	};
	const discardCancelBtnHandler = (
		event: React.MouseEvent<HTMLButtonElement>
	) => {
		event.preventDefault();
		setIsDiscardVisible(false);
		dispatch(setDiscardEditMode({ editMode: true }));

	};

	const discardConfirmBtnHandler = (
		event: React.MouseEvent<HTMLButtonElement>
	) => {
		event.preventDefault();
		navigate(`/case/${caseId}?activeTab=${ActiveTabsOrder.CONFIGURATION}`);
		setIsDiscardVisible(false);
	};

	const handleSchemeCancel = (e:any) => {
		if(isDirty){
			setIsDiscardVisible(true);
			dispatch(setDiscardEditMode({ editMode: false }));
		}
		else{
			discardConfirmBtnHandler(e)
		}
	

	};

	return (
		<>
			{errorMessage && (
				<NotificationGrid show={true} message={errorMessage} type="error" />
			)}
			<div
				style={{ cursor: "pointer" }}
				onClick={(e:any) =>{ 
					
					if(isDirty){
						setIsDiscardVisible(true);
						dispatch(setDiscardEditMode({ editMode: false }));
					}
					else{
						discardConfirmBtnHandler(e)
					}			}}
			>
				<Breadcrumb
					items={[	{
						text: caseName,
						url: `/case/${caseId}?activeTab=${ActiveTabsOrder.CONFIGURATION}`,
						icon: <MotifIcon src={IconoirArrowLeft} />,
					},
						{
							text: t("pages.configuration.schemes.createScheme"),
							url: `/case/${caseId}?activeTab=${ActiveTabsOrder.CONFIGURATION}`,
							icon: <MotifIcon src={IconoirArrowLeft} />,
							disabled: true,
						},
					]}
					ariaLabel="Breadcrumb navigation"
				/>
			</div>
			<PageTitle
				title={"pages.configuration.scheme.primaryTitle"}
				description={"pages.configuration.scheme.primaryDescription"}
			/>

			<div className="motif-col-md-4  mar-t-20" style={{marginBottom:"60px"}}>
				<form onSubmit={handleSubmit(onSubmit)}>
					<div className="form-field mar-b-20">
						<ControlInputBox
							name={SCHEME_NAME}
							control={control}
							required={true}
							isTextArea={false}
							label={"pages.configuration.scheme.formLabels.schemeName"}
							showLabel={true}
							value={""}
						/>
						{errors[SCHEME_NAME] && errors[SCHEME_NAME].type === "required" && (
							<MotifErrorMessage>{t("pages.configuration.scheme.validationMessages.schemeRequired")}</MotifErrorMessage>
						)}
					</div>
					<div className="form-field mar-b-20">
						<ControlInputBox
							name={SCHEME_NAME_FR}
							control={control}
							isTextArea={false}
							label={"pages.configuration.scheme.formLabels.schemeNameFrench"}
							showLabel={true}
							value={""}
						/>
					</div>
					<div className="form-field mar-b-20">
						  <ControlTextAreaWithCharLimit
							name={SCHEME_DESC_NAME}
							control={control}
							isTextArea={true}
							label={"pages.configuration.scheme.formLabels.schemeDescription"}
							showLabel={true}							
							/>
					</div>
					<div className="form-field">
						<ControlTextAreaWithCharLimit
							name={SCHEME_DESC_FR_NAME}
							control={control}
							isTextArea={true}
							label={"pages.configuration.scheme.formLabels.schemeDescriptionFrench"}
							showLabel={true}
						/>
					</div>
				</form>
			</div>
			<div className="motif-row justify-content-end button-container sticky-footer">
				<div className="pad-r-10">
					<MotifButton
						type="button"
						variant={CANCEL_BUTTON_VARIANT}
						className="motif-button btn"
						onClick={handleSchemeCancel}
					>
						{t("global.globalActions.cancel")}
					</MotifButton>
				</div>
				<div className="pad-r-10">
					<Button
						label={t("global.globalActions.save")}
						variant={SAVE_BUTTON_VARIANT}
						className="motif-button"
						type={isLoading ? "loader" : "submit"}
						onClickHandler={handleSubmit(onSubmit)}
					/>
				</div>
			</div>
			<ConfirmationModal
				isVisible={isDiscardVisible}
				setIsVisible={setIsDiscardVisible}
				cancelBtnApproveHandler={discardConfirmBtnHandler}
				cancelBtnRejectHandler={discardCancelBtnHandler}
			/>
		</>
	);
};
export default SchemeSetup;
